module.exports = __webpack_public_path__ + "img/send-button.6f462c60.svg";